import { render, staticRenderFns } from "./BFieldText.vue?vue&type=template&id=21dee93b&"
import script from "./BFieldText.vue?vue&type=script&lang=js&"
export * from "./BFieldText.vue?vue&type=script&lang=js&"
import style0 from "./BFieldText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports